export default __webpack_public_path__ + "static/media/master_card.a2462561.png";